import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { Icon } from '../components/icons';
import { MutationError } from '../components/MutationError';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { fmtDate } from './format';

// EmailBounceNotice: Hinweis am Lead, wenn seine E-Mail-Adresse nach einer Unzustellbarkeitsmeldung gesperrt ist – keine
// E-Mails an Kunden mehr dorthin, bis die Adresse korrigiert oder hier freigegeben wird (OFFENE_FRAGEN D-24).
export function EmailBounceNotice({ leadId, email }: { leadId: string; email?: string | null }) {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const queryClient = useQueryClient();
  const key = projectKeys.emailBounce(project.id, leadId);
  const bounce = useQuery({ queryKey: [...key, email ?? ''], queryFn: ({ signal }) => papi.leadEmailBounce(leadId, signal), enabled: Boolean(email) });
  const clear = useMutation({
    mutationFn: () => papi.clearLeadEmailBounce(leadId),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: key }),
  });
  const b = bounce.data?.bounce;
  if (!email || !b) return null;
  return (
    <div className="bounce-notice" role="alert">
      <Icon name="warning" size={18} />
      <div>
        <strong>E-Mail-Adresse unzustellbar</strong>
        <p>
          {b.reason} {b.code && <span className="muted">(Fehlercode {b.code}, gemeldet am {fmtDate(b.last_bounced_at)})</span>}
        </p>
        <p className="muted">
          E-Mails an Kunden – auch Terminbestätigungen – gehen nicht mehr an diese Adresse. Bitte die Adresse beim Kunden erfragen und korrigieren; eine
          korrigierte Adresse ist sofort frei.
        </p>
        {can('lead.edit') && (
          <button type="button" className="btn btn-small btn-ghost" disabled={clear.isPending} onClick={() => clear.mutate()}>
            Adresse stimmt – wieder freigeben
          </button>
        )}
        {clear.isError && <MutationError error={clear.error} />}
      </div>
    </div>
  );
}
